<template>
  <div class="contractManagement-item-bd">
    <div class="steps">
      <div class="title">
        <i class="icon icon-caidangongneng"></i>
         <span v-if="isCopy">{{
         $t('crm_tryManagement_item.kbsydd')
        }}</span>
        <span v-else-if="!edit">{{
          $t('crm_tryManagement_item.xzsydd')
        }}</span>
        <span v-else>{{
          $t('crm_tryManagement_item.bjsydd')
        }}</span>
      </div>
      <t-step v-model="tabActive" :list="stepList" @change="changeStep"></t-step>
    </div>
    <div class="content-wrap">
      <contract-personParty
        v-if="tabActive === 1"
        :isCopy="isCopy"
        :contractId="contractId"
        :operateFlag='operateFlag'
        @success="nextStep"
        @syncContractId="syncContractId"
        @previous="previous"
        @successJump="onSuccess"
        @cancelJump="onCancel"
      ></contract-personParty>
      <contract-scheme
        v-if="tabActive === 2"
        :contractId="contractId"
        :operateFlag='operateFlag'
        @success="nextStep"
        @previous="previous"
        @successJump="onSuccess"
        @cancelJump="onCancel"
      ></contract-scheme>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import tStep from '@/components/step.vue';
import contractPersonParty from './contract_personPart_trial.vue';
import contractScheme from './contract_scheme_trial.vue';

export default {
  name: 'tryManagement_item',
  provide() {
    return {
      getContractInfo: () => this.contractInfo
    };
  },
  components: {
    tStep,
    // contractInfo,
    contractPersonParty,
    // contractService,
    contractScheme,

  },
  computed: {
    stepList() {
      return [
        {
          label: 1,
          value: 1,
          title: this.$t('crm_tryManagement_item.he_tong_xin_xi')
        },
        {
          label: 2,
          value: 2,
          title: this.$t('crm_tryManagement_item.xuan_ze_she_bei')
        },

      ];
    },
    // isCopy() {
    //   return this.getJump('copy');
    // }
  },
  data() {
    return {
      provide: true,
      tabActive: 1,
      contractId: '',
      // contractClass: '',
      edit: false,
      // 唯一标识
      operateFlag: '',
      contractInfo: {},
      isCopy: false
    };
  },
  mounted() {

    // 获取id   有去获取详情 无就新增
    this.contractId = this.getJump('contractId');
    // this.contractClass = this.getJump('contractClass');
    // this.isCopy = this.getJump('copy');
    // 获取详情
    this.getContractDetail();
    if (this.getJump('contractId')) {
      this.edit = true;
    }
    if (this.getJump('copy')) {
      this.isCopy = true;
    }
    // this.getOssConfig();
    // 生成唯一标识
    this.operateFlag = this.$genNonDuplicateID();
  },
  methods: {
    // 合同详情
    getContractDetail: function () {
      if (!this.contractId) {
        return;
      }
      this.$getJSON(apis.trialOrderInfo, { bizId: this.contractId }).then((res) => {
        // this.$setFormatData(this.form, data);
        this.contractInfo = res.data;
      });
    },


    // 点击步骤
    // clickStep: function (num) {
    //   if (this.edit && num < this.stepList.length) {
    //     this.tabActive = num;
    //   }
    // },
    // 编辑的时候点击步骤
    changeStep: function (arg) {
      if (this.edit && !this.isCopy) {
        this.tabActive = arg.value;
      }
    },
    // 完成
    onSuccess: function () {
      this.clearTagByKeep('tryManagement_item');
      this.jump('/contract/trialOrder', {}, true);
    },
    // 取消
    onCancel: function () {
      this.clearTagByKeep('tryManagement_item');
      this.jump('/contract/trialOrder', {}, true);
    },
    // 上一步
    preStep: function () {
      --this.tabActive;
    },
    previous: function () {
      this.tabActive = --this.tabActive;
    },
    // 初始化
    nextStep: function () {
      this.tabActive = ++this.tabActive;
      // this.tabActive = num;
      // if (num === 3) {
      //   this.tabActive = 3;
      // }
      this.clearKeepAlive('trialOrderManagement');
    },

    syncContractId: function (contractId) {
      this.contractId = contractId;
      // this.contractClass = contractClass;
      // 更新
      this.getContractDetail();
    },

    // 关闭弹窗
    closeDialog: function () {
      this.$emit('input', false);
    },
  }
};
</script>

<style lang="scss">
@import "@/style/colors.scss";

.contractManagement-item-bd {
  height: 100%;
  position: relative;
  overflow: auto;
  .steps {
    position: absolute;
    left: 0;
    top: 0;
    width: 220px;
    bottom: 0;
    background-color: #f9f9fd;
    .title{
      height: 70px;
      line-height: 70px;
      padding-left: 18px;
      font-size:14px;
      font-weight:bold;
      color:rgba(57,70,104,1);
      .icon{
        color: #0D9AE0;
        // color: $main-color;
        font-size: 13px;
        margin-right:10px;
      }
    }
  }
  .content-wrap {
    background-color: #ffffff;
    margin-left: 220px;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    .content {
      display: flex;
      flex-direction: column;
      height: 100%;
      .content-box {
        flex: 1;
        padding: 24px ;
        overflow-y: auto;
        display: flex;
        flex-direction: column;
        .title {
          line-height: 24px;
          font-size: 14px;
          position: relative;
          color: #35405B;
          margin-bottom: 24px;
          font-weight: bold;
        }
        // 地址
        .address-box {
          > h3 {
            color: #000;
            padding-bottom: 16px;
            line-height: 24px;
          }
          .address-btn {
            border: 2px dashed #00afff;
            position: relative;
            height: 80px;
            line-height: 80px;
            text-align: center;
            font-size: 40px;
            color: rgba(0, 0, 0, 0.45);
          }
          .address-item {
            border: 2px dashed #00afff;
            position: relative;
            height: 80px;
            padding: 12px 16px;
            h3 {
              line-height: 24px;
              height: 24px;
              font-size: 12px;
              color: #1e1e1e;
              font-weight: bold;
              border: none;
            }
            p {
              font-size: 12px;
              line-height: 24px;
              color: #666;
              margin-top: 8px;
              height: 24px;
            }
            .address-modify-btn {
              position: absolute;
              right: 16px;
              bottom: 10px;
              font-size: 12px;
               line-height: 24px;
              color: #f33a73;
            }
            .address-default {
              position: absolute;
              top: 0;
              right: 0;
              font-size: 12px;
              color: #fff;
              padding: 0 13px;
              background: rgba(0, 0, 0, 0.19);
              border-radius: 0px 0px 0px 100px;
            }
          }
        }

        // 租赁方案
        .lease-list {
          margin-bottom: 30px;
          ul {
            // padding: 30px 0 0px;
            // border: 1px solid #E4E4E4;
            li {
              // margin-top: 10px;
              background: #fff;
              border-bottom: 1px solid #eef2f8;
              &:first-child {
                margin-top: 0;
                background: whitesmoke;
              }
              // .el-input__inner{
              //   height: 30px;
              //   line-height: 30px;
              //   width: 100%;
              // }
            }
          }

          .item {
            height: 50px;
            padding: 10px;
            // margin-bottom: 10px;
            // padding-top: 0;
            // background: rgba(245, 245, 245, 1);
            // border: 1px solid rgba(228, 228, 228, 1);
            line-height: 30px;
            font-size: 12px;
            // >.el-col{
            //   line-height: 30px;
            // }
            .icon-box {
              line-height: 30px;
              width: 30px;
              // margin-left: 10px;
              text-align: center;
              text-align: center;
              cursor: pointer;
              .icon {
                color: #00afff;
                font-size: 14px;
              }
            }
          }
          .formContact-title {
            height: 40px;
            padding: 10px;
            line-height: 20px;
          }
        }

      }
      .btn-group {
        border-top: 1px solid #eef2f8;
        padding: 16px 0 16px 24px;
        height: 60px;
        z-index: 1;
        -webkit-box-flex: 0;
        flex: 0 0 60px;
      }
    }
  }
  .info-box,
  .party-box,
  .scheme—box,
  .service—box,
  .payment-box,
  .contract-box {
    // display: flex;
    width: 100%;
    // flex-direction: column;
    .content {
      flex: 1;
      // display: flex;
      // width: 1100px;
      // margin: 0 auto 40px;
      padding: 30px;
      .content-main {
        // padding: 30px;
        flex: 1;

        .party-a,
        .party-b,
        .contract-a,
        .contract-b {
          padding: 0 33px;
        }
        .party-b,
        .contract-b {
          border-left: 1px solid #eef2f8;
        }


        .change-address {
          color: #00afff;
          cursor: pointer;
        }
        .dashed {
          margin: 32px 0;
          border-bottom: 1px dashed #eef2f8;
        }

        // 合同
        .contract-head {
          display: flex;
          p {
            flex: 1;
          }
          .contract-head-btn {
            align-self: flex-end;
          }
        }
        .contract-a,
        .contract-b {
          text-align: center;
          .contract-description {
            h3 {
              font-size: 26px;
              line-height: 40px;
            }
            p {
              font-size: 16px;
              line-height: 26px;
            }
          }
          .wait-btn {
            display: inline-block;
            background-color: #fff;
            border: 1px dashed #d9d9d9;
            border-radius: 6px;
            -webkit-box-sizing: border-box;
            box-sizing: border-box;
            width: 360px;
            height: 180px;
            line-height: 180px;
            font-size: 26px;
            color: #b2afaf;
          }
        }
      }
    }
    .btn-group {
      // position: absolute;
      border-top: 1px solid rgba(0, 0, 0, 0.05);
      padding-top: 18px;
      // bottom: 0;
      height: 70px;
      // left: 250px;
      // right: 0;
      text-align: center;
      // background-color: #F4F4F4;
      z-index: 1;
      flex: 0 0 70px;
    }
  }


  .limit-pic .el-upload--picture-card {
    display: none;
  }
}
</style>
